import type { ShipSnapshot } from "@frontier/protocol/contracts";

export const COMBAT_VFX_LIMITS = {
  impacts: 48,
  explosions: 16,
  projectileTrails: 128,
  spareProjectiles: 256,
} as const;

export interface CombatImpact {
  kind: "shield" | "hull";
  x: number;
  y: number;
  radius: number;
}

export interface ShipCombatImpact extends CombatImpact {
  shipId: string;
  shieldHit: boolean;
}

export function confirmedShipImpacts(
  previous: ReadonlyMap<string, ShipSnapshot>,
  current: readonly ShipSnapshot[],
): ShipCombatImpact[] {
  const impacts: ShipCombatImpact[] = [];
  for (const ship of current) {
    const old = previous.get(ship.id);
    if (
      !old ||
      old.dead ||
      ship.dead ||
      old.docked ||
      ship.docked ||
      old.sectorId !== ship.sectorId ||
      old.hullId !== ship.hullId ||
      old.maxHp !== ship.maxHp ||
      old.maxShield !== ship.maxShield ||
      (old.controls?.flightId ?? null) !== (ship.controls?.flightId ?? null) ||
      Math.hypot(ship.x - old.x, ship.y - old.y) > 300
    )
      continue;
    if (ship.hp < old.hp || ship.shield < old.shield)
      impacts.push({
        shipId: ship.id,
        shieldHit: ship.shield < old.shield,
        kind: ship.hp < old.hp ? "hull" : "shield",
        x: ship.x,
        y: ship.y,
        radius: Math.max(16, ship.radius * 1.45),
      });
  }
  return impacts;
}
